import React, { Fragment } from 'react';
import ModernHeader from '../header/ModernHeader';
import ModernFooter from '../footer/ModernFooter';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import '../../styles/design-system.scss';
import './PageLayout.scss';

const PageLayout = ({ children, solidHeader = false }) => {
    return (
        <Fragment>
            <div className={`jk-app${solidHeader ? ' jk-app--solid-header' : ''}`}>
                <ModernHeader forceSolid={solidHeader} />
                <main className="jk-main">
                    {children}
                </main>
                <ModernFooter />
                <ScrollToTop />
            </div>
        </Fragment>
    );
};

export default PageLayout;
